import { render, staticRenderFns } from "./SettingsNotificationsExtra.vue?vue&type=template&id=784e6100&"
import script from "./SettingsNotificationsExtra.vue?vue&type=script&lang=js&"
export * from "./SettingsNotificationsExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports